export default "__VITE_ASSET__B87Nc5UE__"